    <template>
    <div class="feedback-preference">
        <body-feedback
            :index="index"
            :beforeBold="$t('views.feedback.preference.beforeBold')"
            :titleBold="$t('views.feedback.preference.titleBold')"
            actionName="sendPreference">
            <option-select 
                :options="options" 
                typeOption="radio"
                itemName="preferredEvaluationModel"></option-select>
        </body-feedback>
    </div>
</template>
<script>
import BodyFeedback from '../../components/feedback/BodyFeedback.vue'
import OptionSelect from '../../components/shared/default/OptionSelect.vue'
import { Bus } from '../../event-bus.js'
export default {
    components : {
        BodyFeedback,
        OptionSelect
    },
    props:["index"],
    data(){
        return{
            options : [
                {
                    text : this.$t("views.feedback.preference.options[0]"),
                    value : 'games'
                },
                {
                    text : this.$t("views.feedback.preference.options[1]"),
                    value : 'conventional'
                },
                {
                    text : this.$t("views.feedback.preference.options[2]"),
                    value : 'self-evaluation'
                }
            ]
        }
    },
    created(){
        Bus.$on('sendPreference', this.sendPreference)
    },
    destroyed(){
        Bus.$off('sendPreference')
    },
    methods: {
        sendPreference(){
            Bus.$emit('nextStep')
            this.$router.push('/feedback-explain')
        }
    }
}
</script>
<style lang="scss" scoped>
    .feedback-preference{
        height: 100%;
    }
</style>


